"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFetchingClients = exports.isFetchClientsFail = exports.isEmptyClients = exports.getSavingClaimIndicatorsByKey = exports.getClients = exports.getClientByIndex = void 0;
var _reselect = require("reselect");
var _ramda = require("ramda");
var EMPTY_OBJ = {};
var domain = function domain(_) {
  return _.saveToClaimModal;
};
var isFetchingClients = exports.isFetchingClients = (0, _ramda.pipe)(domain, (0, _ramda.prop)('isFetchingClients'));
var isFetchClientsFail = exports.isFetchClientsFail = (0, _ramda.pipe)(domain, (0, _ramda.prop)('isFetchClientsFail'));
var getClients = exports.getClients = (0, _ramda.pipe)(domain, (0, _ramda.prop)('clients'));
var getClientByIndex = exports.getClientByIndex = (0, _ramda.converge)(function (clients, index) {
  return clients[index];
}, [getClients, function (_, _ref) {
  var index = _ref.index;
  return index;
}]);
var isEmptyClients = exports.isEmptyClients = (0, _ramda.pipe)(getClients, _ramda.isEmpty);
var getSavingClaimIndicators = (0, _ramda.pipe)(domain, (0, _ramda.prop)('savingClaimIndicators'));
var getSavingClaimIndicatorsByKey = exports.getSavingClaimIndicatorsByKey = function getSavingClaimIndicatorsByKey() {
  return (0, _reselect.createSelector)(getSavingClaimIndicators, function (_, _ref2) {
    var indicatorsKey = _ref2.indicatorsKey;
    return indicatorsKey;
  }, function (indicators, indicatorsKey) {
    return (0, _ramda.propOr)(EMPTY_OBJ, indicatorsKey, indicators);
  });
};